export class GeoObject {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.modelSection = modelSection ?? null;
        this.objectType = data.objectType ?? null;
        this.elevationTop = data.elevationTop ?? null;
        this.elevationBottom = data.elevationBottom ?? null;
        this.thickness = data.thickness ?? null;
        this.verticalLevelTop = data.verticalLevelTop ?? null;
        this.verticalLevelBottom = data.verticalLevelBottom ?? null;
        this.notes = data.notes ?? null;

    }

    get geoSection() {
        return this.modelSection?.geoSection ?? null;
    }

    get elevationOfZeroDatumLevel() {
        return this.geoSection?.elevationOfZeroDatumLevel ?? null;
    }

}
